import React from 'react';

export const CuripodAIStarsSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="47"
    height="45"
    viewBox="0 0 47 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_29723_48850" fill="white">
      <path d="M0.150391 5C0.150391 2.23858 2.38897 0 5.15039 0H41.8487C44.6101 0 46.8487 2.23858 46.8487 5V39.3115C46.8487 42.0729 44.6101 44.3115 41.8487 44.3115H5.1504C2.38897 44.3115 0.150391 42.0729 0.150391 39.3115V5Z" />
    </mask>
    <path
      d="M0.150391 5C0.150391 2.23858 2.38897 0 5.15039 0H41.8487C44.6101 0 46.8487 2.23858 46.8487 5V39.3115C46.8487 42.0729 44.6101 44.3115 41.8487 44.3115H5.1504C2.38897 44.3115 0.150391 42.0729 0.150391 39.3115V5Z"
      fill="url(#paint0_linear_29723_48850)"
    />
    <path
      d="M0.150391 0H46.8487H0.150391ZM46.8487 39.3115C46.8487 42.6252 44.1624 45.3115 40.8487 45.3115H6.15039C2.83668 45.3115 0.150391 42.6252 0.150391 39.3115C0.150391 41.5207 2.38897 43.3115 5.15039 43.3115H41.8487C44.6101 43.3115 46.8487 41.5207 46.8487 39.3115ZM0.150391 44.3115V0V44.3115ZM46.8487 0V44.3115V0Z"
      fill="white"
      fillOpacity="0.1"
      mask="url(#path-1-inside-1_29723_48850)"
    />
    <path
      d="M22.4839 19.3257C24.9146 17.2444 25.5844 8.27959 25.5844 8.27959C25.5844 8.27959 25.4075 16.6509 28.1005 19.4773C30.3469 21.8352 35.6622 21.6285 36.7076 21.5631C36.8244 21.554 36.8878 21.5503 36.8878 21.5503C36.8878 21.5503 36.8242 21.5558 36.7076 21.5631C35.6709 21.6447 30.4301 22.1641 27.995 24.4656C25.2858 27.0264 24.9982 36.0309 24.9982 36.0309C24.9982 36.0309 24.8921 27.4798 22.3785 24.3141C20.5062 21.9561 16.3926 21.2173 14.6788 21.0067C14.1961 20.9708 13.9055 20.9301 13.9055 20.9301C13.9055 20.9301 14.1974 20.9475 14.6788 21.0067C16.345 21.1305 20.2993 21.1962 22.4839 19.3257Z"
      fill="url(#paint1_linear_29723_48850)"
    />
    <path
      d="M18.6919 31.8825C19.1548 31.4803 19.1382 29.9383 19.1382 29.9383C19.1382 29.9383 19.2458 31.3696 19.8469 31.7992C20.3484 32.1578 21.4355 32.0193 21.6489 31.9878C21.6727 31.984 21.6857 31.9822 21.6857 31.9822C21.6857 31.9822 21.6727 31.9843 21.6489 31.9878C21.4376 32.022 20.3711 32.2123 19.911 32.6521C19.3991 33.1415 19.4949 34.6828 19.4949 34.6828C19.4949 34.6828 19.3262 33.2265 18.7559 32.7353C18.3313 32.3696 17.4745 32.3235 17.1192 32.3208C17.0196 32.324 16.9592 32.3227 16.9592 32.3227C16.9592 32.3227 17.0194 32.3201 17.1192 32.3208C17.4632 32.3096 18.2757 32.244 18.6919 31.8825Z"
      fill="url(#paint2_linear_29723_48850)"
    />
    <path
      d="M14.1515 27.3765C13.2688 28.2852 13.3057 31.8412 13.3057 31.8412C13.3057 31.8412 13.0953 28.537 11.946 27.522C10.987 26.6752 8.91142 26.9509 8.50404 27.0148C8.45853 27.0227 8.43389 27.0265 8.43389 27.0265C8.43389 27.0265 8.45848 27.022 8.50404 27.0148C8.90753 26.9448 10.9434 26.5487 11.8205 25.5531C12.7966 24.4453 12.6085 20.8876 12.6085 20.8876C12.6085 20.8876 12.9356 24.2523 14.0262 25.4075C14.8385 26.268 16.4749 26.4087 17.1534 26.4291C17.3437 26.4256 17.4589 26.431 17.4589 26.431C17.4589 26.431 17.344 26.4348 17.1534 26.4291C16.4964 26.4412 14.945 26.5598 14.1515 27.3765Z"
      fill="url(#paint3_linear_29723_48850)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_29723_48850"
        x1="0.150391"
        y1="22.1557"
        x2="46.8487"
        y2="22.1557"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.379808" stopColor="#FFA55B" />
        <stop offset="1" stopColor="#FFC107" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_29723_48850"
        x1="24.536"
        y1="10.404"
        x2="22.3262"
        y2="34.6361"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.278846" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.36" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_29723_48850"
        x1="19.5937"
        y1="29.8512"
        x2="16.9395"
        y2="33.0946"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.259615" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.48" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_29723_48850"
        x1="13.5209"
        y1="21.7237"
        x2="9.38498"
        y2="28.7231"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.424189" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.3" />
      </linearGradient>
    </defs>
  </svg>
);

export default CuripodAIStarsSvg;
